import Image from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import trueImage from '@/components/ielts/listening/assets/images/true.png';
import falseImage from '@/components/ielts/listening/assets/images/false.png';

type Props = {
  className?: string;
  result?: boolean;
};

function IeltsInputResultIcon({ className, result }: Props) {
  const renderResult = () => {
    switch (result) {
      case true: {
        return (
          <Image
            src={trueImage}
            alt=""
            width={310}
            height={240}
            className="w-[24px] h-[19px] max-lg:w-[18px] max-lg:h-[16px]"
          />
        );
      }
      case false: {
        return (
          <Image
            src={falseImage}
            alt=""
            width={290}
            height={240}
            className="w-[24px] h-[19px] max-lg:w-[18px] max-lg:h-[16px]"
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  return <div className={twMerge(className)}>{renderResult()}</div>;
}

export default IeltsInputResultIcon;
